module.exports = __webpack_public_path__ + "img/diamond-black.f99e2c32.png";